import {
  PlanTask,
  usePlanTasksService
} from 'nekst-api';

export interface ProjectPlanTask extends PlanTask {
  calculatedDueDate: Nullable<Date>;
}

export interface ProjectPlanTaskService {
  getTasksByPlanId: (planId: number) => Promise<ProjectPlanTask[]>;
}

function getNoDueDateStubDate(): Date {
  return new Date('2099-01-01');
}

export default function useProjectPlanTaskService(): ProjectPlanTaskService {
  const planTasksService = usePlanTasksService();

  function getParentTaskRelationDays(task: ProjectPlanTask): number {
    const result = task.parentTaskRelation?.days || 0;

    if (task.parentTaskRelation?.isProceeding) {
      return -result;
    } else {
      return result;
    }
  }

  const tasksCompareFunc = (task1: ProjectPlanTask, task2: ProjectPlanTask) => {
    const date1 = task1.calculatedDueDate ? new Date(task1.calculatedDueDate) : getNoDueDateStubDate();
    const date2 = task2.calculatedDueDate ? new Date(task2.calculatedDueDate) : getNoDueDateStubDate();

    if (date1.getTime() !== date2.getTime()) {
      return date1.getTime() - date2.getTime();
    } else if (task1.order !== task2.order) {
      return task1.order - task2.order;
    } else {
      let compareResult = 0;

      if (task1.parentTaskRelation?.parentTaskId && task1.parentTaskRelation.parentTaskId === task2.parentTaskRelation?.parentTaskId) {
        compareResult = getParentTaskRelationDays(task1) - getParentTaskRelationDays(task2);
      }

      if (compareResult !== 0) {
        return compareResult;
      } else {
        return task1.name.localeCompare(task2.name);
      }
    }
  };

  const getTasksByPlanId = async (planId: number) => {
    const tasks = await planTasksService.getPlanTasks(planId);

    const result = tasks
      .map((task) => {
        return {
          ...task,
        } as ProjectPlanTask;
      });

    result.sort(tasksCompareFunc);

    return result;
  };

  return {
    getTasksByPlanId,
  };
}
